import { Pipe, PipeTransform } from '@angular/core';
import { MatchSorterOptions, matchSorter } from 'match-sorter';

@Pipe({
  name: 'matchSorter',
  standalone: true,
})
export class MatchSorterPipe implements PipeTransform {
  transform<ItemType>(
    items: ReadonlyArray<ItemType>,
    value: string,
    options?: MatchSorterOptions<ItemType> & { multiWord?: boolean }
  ): ItemType[] {
    if (!options || !options.multiWord) {
      return matchSorter(items, value, options);
    }

    if (!value || !value.length) {
      return [...items];
    }

    const terms = value.split(' ');
    if (!terms) {
      return [...items];
    }

    // reduceRight will mean sorting is done by score for the _first_ entered word.
    return terms.reduceRight(
      (results, term) => matchSorter(results, term, options),
      [...items]
    );
  }
}
